// extracted by mini-css-extract-plugin
export default {"container":"CallCenterDashboard_container__46ePm","statsGrid":"CallCenterDashboard_statsGrid__Hg52G","middleRow":"CallCenterDashboard_middleRow__hfm6R"};